import {SpecialCategories} from './uploads';

import {defineExpenseOverrides, expenseDataModuleFactory} from '../utils/expense-data';

// noinspection JSUnusedGlobalSymbols
const overrides = defineExpenseOverrides({
   getters: {
      declaration: (state, getters, rootState, rootGetters) => {
         return rootGetters['companies/activeStudy']?.supplies.declared;
      },

      /** The declared location, provided the section has a declaration of 'ONE' location */
      location: (state, getters, rootState, rootGetters) => {
         return rootGetters['companies/activeStudy']?.supplies.location;
      },
   },

   actions: {
      /** Update the section declaration */
      async saveDeclaration({dispatch}, {companyId, value, location}) {
         let payload = {
            declared: value,
         };
         if (location !== null) {
            payload.location = location;
         }
         await dispatch('_saveSectionData', {companyId, payload});
      },

      async validate({commit}, {companyId, periodId}) {
         await this._vm.$http.post(`/api/company/${companyId}/supplies/${periodId}/validate`);
         commit('addValidatedPeriod', {periodId});
      },
   },
});

export default expenseDataModuleFactory('supplies', SpecialCategories.SUPPLIES_DOCS, overrides);
